module.exports = "/fonts/vendor/@fontsource/inter/files/inter-all-200-normal.woff?70d0697e14a0f6765aeda567280b20b0";